import React from "react";
import Navbar from "@/components/Navbar";
import { COMPANY } from "@/constants/company";

// Shared chrome for the four public policy pages, so they read as one document
// set rather than four pages that drifted apart.
export default function PolicyLayout({ eyebrow, title, intro, testId, children }) {
    return (
        <div className="min-h-screen magic-bg">
            <Navbar />
            <div className="max-w-2xl mx-auto px-6 py-14" data-testid={testId}>
                <div className="text-xs tracking-[0.28em] uppercase text-plum/60 mb-3">{eyebrow}</div>
                <h1 className="font-display text-4xl tracking-tight mb-3">{title}</h1>
                {intro && <p className="text-plum/70 leading-relaxed mb-8">{intro}</p>}
                <div className="space-y-6">{children}</div>
                <div className="text-xs text-plum/40 mt-12">
                    Last updated {COMPANY.updated} · {COMPANY.legalName}
                </div>
            </div>
        </div>
    );
}

export function Section({ heading, children }) {
    return (
        <section className="card-cloud p-6">
            <h2 className="font-display text-xl mb-3">{heading}</h2>
            <div className="text-sm text-plum/80 leading-relaxed space-y-3">{children}</div>
        </section>
    );
}
